<template>
  <div class="ba-container ba-gp-08 ba-ai-baseline ba-w-100 ba-grid">
    <div v-if="showExitPopupAlert" class="ba-alert ba-info ba-w-100">
      <span v-text="$t('ct-bundle-exit-popup-message')"></span>
    </div>
    <Breadcrumbs v-if="$route.name == 'Home'" />
    <builderall-loader
      v-if="!notHaveWebsites"
      :loading="loadingContentData || loadingAll"
      class="ba-w-100"
    >
      <div class="ba-w-100">
        <div>
          <!-- Websites Published -->
          <div v-if="!selectMirrors">
            <div v-if="showMainSiteCard" class="master-website">
              <main-site-card-component
                :config="mainWebsite"
                :categories="categories"
                :type_view="typeView"
                :select-websites="selectWebsites"
                :key="mainWebsite.id"
                website_type="websites"
                @openCategory="openNewCategory"
                @updateWebsites="updateWebsites"
                @uploadImagePage="uploadImagePage"
                @openPublicLink="openPublicLink"
                @publish="publish"
                @changeUnitary="changeUnitary"
                @checkedSelectAll="checkedSelectAll"
                @updateFavorite="updateFavorite"
              />
            </div>

            <div v-if="websites.normal.length > 1 || websites.mirrors.length > 1 || hasFilters" class="ba-card ba-w-100 ba-mg-t-1 ba-mg-b-1">
              <div class="ba-flex ba-jc-sb ba-ai-center ba-w-100">
                <div class="ba-flex">
                  <div v-if="typeView !== 'maincard'" class="builder-action-multiple-websites_checkbox-all pr-2">
                    <button
                      v-if="selectWebsites.type === 'all' || selectWebsites.total > 0"
                      class="ba-btn ba-btn-trash ba-sm ba-rounded mr-2"
                      @click="deletedWebsites"
                    >
                      <builderall-icon code="trash" />
                    </button>
                    <input
                      id="select-websites-all"
                      ref="select-all-websites"
                      :checked="selectWebsites.type === 'all'"
                      type="checkbox"
                      class="mr-2"
                      @change.prevent="selectedWebsitesAll"
                    >
                    <label
                      v-if="selectWebsites.type === 'unitary'"
                      for="select-websites-all"
                      class="builder-action-multiple-websites_checkbox-all-label"
                    >
                      {{ $t("ct-websites-selected-all") }}
                    </label>
                    <label
                      v-if="selectWebsites.type === 'all'"
                      for="select-websites-all"
                      class="builder-action-multiple-websites_checkbox-all-label"
                    >
                      {{ $t("ct-websites-unselect-all") }}
                    </label>
                  </div>
                  <div v-if="typeView == 'maincard'">
                    <label class="builder-action-multiple-websites_checkbox-all-label">
                      {{ $t("ct-show-more") }}
                    </label>
                  </div>
                </div>
                <div class="ba-flex ba-gp-08 ba-ai-center">
                  <select class="ba-select ba-md" v-model="filterSitesOrder">
                    <option value="edition_asc">{{ $t("ct-edition") }}</option>
                    <option value="alphabetical_desc">Z - A</option>
                    <option value="alphabetical_asc">A - Z</option>
                    <option value="creation_asc">
                      {{ $t("ct-creation") }} {{ $t("ct-ascending") }}
                    </option>
                    <option value="creation_desc">
                      {{ $t("ct-creation") }} {{ $t("ct-descending") }}
                    </option>
                  </select>
                  <select class="ba-select ba-md" v-model="filterPublishedUnpublished">
                    <option value="">{{ $t("ct-all") }}</option>
                    <option value="active">{{ $t("ct-published") }}</option>
                    <option value="inactive">{{ $t("ct-unpublished") }}</option>
                    <option value="favorites">{{ $t("ct-favorites") }}</option>
                    <option value="mirrors">{{ $t("ct-mirror-websites") }}</option>
                  </select>
                  <div class="dashboard-choose-view ba-flex ba-ai-center ba-gp-06">
                    <div
                      :class="{ selected: typeView === 'maincard' }"
                      @click="typeView = 'maincard'"
                    >
                      <svg width="30" height="30" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.5001 26.0002C9.5001 26.5498 9.0501 27.0001 8.5002 27.0001H4.0002C3.45 27.0001 3 26.5498 3 26.0002V21.5002C3 20.9503 3.45 20.5 3.9999 20.5H8.4999C9.0498 20.5 9.4998 20.9503 9.4998 21.5002L9.5001 26.0002Z"/>
                        <path d="M18.2498 26.0002C18.2498 26.5498 17.7998 27.0001 17.2499 27.0001H12.7499C12.2 27.0001 11.75 26.5498 11.75 26.0002V21.5002C11.75 20.9503 12.2 20.5 12.7499 20.5H17.2499C17.7998 20.5 18.2498 20.9503 18.2498 21.5002V26.0002Z"/>
                        <path d="M27 17.25C27 17.7999 26.5497 18.2499 26.0001 18.2499H3.9999C3.45 18.2499 3 17.7999 3 17.25V3.9999C3 3.45 3.45 3 3.9999 3H25.9998C26.5497 3 27 3.45 27 3.9999V17.25Z"/>
                        <path d="M27.0001 26.0002C27.0001 26.5498 26.5498 27.0001 26.0002 27.0001H21.5002C20.9503 27.0001 20.5 26.5498 20.5 26.0002V21.5002C20.5 20.9503 20.9503 20.5 21.5002 20.5H26.0002C26.5498 20.5 27.0001 20.9503 27.0001 21.5002V26.0002Z"/>
                      </svg>
                    </div>
                    <div
                      :class="{ selected: typeView === 'card' }"
                      @click="typeView = 'card'"
                    >
                      <i class="ct-icon-dash-card" />
                    </div>
                    <div
                      :class="{ selected: typeView === 'list' }"
                      @click="typeView = 'list'"
                    >
                      <i class="ct-icon-dash-list" />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="custom-container">
              <div v-if="pagination.normal.current_page === 1 && websites.normal.length > 4 && typeView === 'maincard'" class="maincard-header ba-flex ba-jc-sb ba-ai-center">
                <h4 class="maincard-title ba-mg-t-1 ba-mg-b-1">{{ $t('ct-recent-websites') }}</h4>
                <button @click="typeView = 'card'" class="maincard-view-all">
                  <span>{{ $t('ct-view-all') }}</span>
                  <builderall-icon code="arrow-right" />
                </button>
              </div>
              <div class="container-box col-sm-12 col-md-12 col-12 col-lg-12">
                <template v-if="loading">
                  <skeleton-card-site-component
                    v-for="n in skeletonCount"
                    :key="`${n}-published`"
                  />
                </template>
                <template v-else>
                  <site-card-component
                    v-for="website in displayWebsites"
                    :config="website"
                    :categories="categories"
                    :key="website.id"
                    :type_view="typeView"
                    :select-websites="selectWebsites"
                    website_type="websites"
                    @openCategory="openNewCategory"
                    @updateWebsites="updateWebsites"
                    @uploadImagePage="uploadImagePage"
                    @openPublicLink="openPublicLink"
                    @publish="publish"
                    @changeUnitary="changeUnitary"
                    @checkedSelectAll="checkedSelectAll"
                    @updateFavorite="updateFavorite"
                  />
                </template>
              </div>
            </div>

            <div
              class="ba-mg-t-2 ba-flex ba-gp-1 ba-f-column ba-ai-end"
              v-if="showPagination"
            >
              <!--
              <a
                @click="showMore(10)"
                class="show-more ba-flex ba-gp-1 ba-ai-center"
                v-if="typeView !== 'maincard' && pagination.normal.current_page == 1"
              >
                {{ $t("ct-show-more") }}
                <span class="ba-flex ba-ai-center ba-jc-center">10+</span>
              </a>
              -->
              <pagination-component
                :pagination="pagination.normal"
                :offset="4"
                @paginate="paginationChange"
              />
            </div>
          </div>

          <!-- Websites mirrors -->
          <div v-else>
            <button class="ba-btn ba-md ba-light" @click="selectMirrors = false; filterPublishedUnpublished = 'active'">
              <builderall-icon code='arrow-left' style="--builderall-icon-color: #486688; --builderall-icon-size: 17px;"></builderall-icon>
              {{ $t("ct-back") }}
            </button>
            <div class="custom-container ba-mg-t-1">
              <div class="container-box col-sm-12 col-md-12 col-12 col-lg-12">
                <template v-if="loading">
                  <skeleton-card-site-component
                    v-for="n in websitesLength.mirrors"
                    :key="`${n}-unpublished`"
                  />
                </template>
                <template v-else>
                  <div
                    v-if="websites.mirrors.length === 0"
                    class="row w-100 px-5 my-4"
                  >
                    <h1
                      class="text-center text-secondary w-100"
                      v-text="$t('ct-no-mirrors-yet')"
                    />
                  </div>

                  <site-card-component
                    v-for="(website, index) in websites.mirrors"
                    :config="website"
                    :categories="categories"
                    :key="index"
                    :type_view="typeView"
                    :select-websites="selectWebsites"
                    website_type="mirror"
                    @openCategory="openNewCategory"
                    @updateWebsites="updateWebsites"
                    @uploadImagePage="uploadImagePage"
                    @openPublicLink="openPublicLink"
                    @publish="publish"
                    @changeUnitary="changeUnitary"
                    @checkedSelectAll="checkedSelectAll"
                    @updateFavorite="updateFavorite"
                  />
                </template>
              </div>
            </div>

            <div
              class="ba-pd-2 ba-mg-t-1"
              v-if="
                pagination.mirrors &&
                pagination.mirrors.total > pagination.mirrors.per_page
              "
            >
              <pagination-component
                :pagination="pagination.mirrors"
                :offset="4"
              />
            </div>
          </div>

          <div v-if="!websites.mirrors.length && !websites.normal.length">
            <builderall-empty-image />
          </div>

          <!-- Websites Unpublished -->
          <site-new-component
            v-if="typeView === 'card'"
            :new-site="newSite"
            :categories="categories"
            :languages="languages"
            @confirmSave="confirmSave"
            @clearNewSite="clearNewSite"
            @closeModal="closeModal"
            @reloadWebsites="getWebsitesData"
          />
        </div>
      </div>
    </builderall-loader>

    <FirstWebsite v-show="notHaveWebsites" />

    <site-transfer-component
      :site="modal.transfer.config"
      :show="modal.transfer.show"
      @updateWebsites="updateWebsites"
    />

    <site-publish-component
      ref="publish-modal"
      :website="modal.publish.config"
      :show="modal.publish.show"
      @updateWebsites="updateWebsites"
      @openSaveTour="openSaveTour"
      @cancel="cancelModal('publish')"
    />

    <template
      v-if="modal.saveTour.config"
    >
      <save-website-component
        :id_website="modal.saveTour.config.encrypted_id"
        :type="modal.saveTour.type"
        :show="modal.saveTour.show"
        @closeAction="cancelModal('saveTour')"
      />
    </template>

    <site-public-link-component
      :site="modal.publicLink.config"
      :action="modal.publicLink.action"
      :show="modal.publicLink.show"
      @openPublicLink="openPublicLink"
      @updateWebsites="updateWebsites"
    />

    <modal-delete-component
      :show="modal.delete.show"
      :values="modal.delete.config"
      @cancel="cancelModal('delete')"
      @exclude="deleteWebsite"
    />

    <site-category-component
      ref="categoryModal"
      @updateWebsites="updateWebsites"
      @newCategory="newCategory"
      @cancel="cancelCategory"
    />

    <move-category
      :show="modal.moveCategory.show"
      :config="modal.moveCategory.website"
      :categories="categories"
      @openNewCategory="openNewCategory"
      @updateWebsites="updateWebsites"
    />

    <!-- MODAL DELETE SELECT WEBSITES   -->
    <sweet-modal
      ref="confirmDeleteSelectedWebsites"
      width="496px"
      hide-close-button
      class="modal-confirm-deleted-websites"
      blocking
    >
      <alert-box-new-component :with_icon="true" type="danger">
        <span slot="content">{{ $t("ct-modal-deleted-attention") }}</span>
      </alert-box-new-component>
      <p v-if="selectWebsites.selectedWebsites.length === 1">
        {{ $t("ct-modal-deleted-website-description") }}
      </p>
      <p v-else>{{ $t("ct-modal-deleted-websites-description") }}</p>

      <button
        slot="button"
        class="btn btn-outline-light"
        @click.prevent="$refs.confirmDeleteSelectedWebsites.close()"
      >
        {{ $t("ct-cancel") }}
      </button>
      <button
        slot="button"
        class="btn btn-danger"
        @click.prevent="confirmDeletedWebsites"
      >
        {{ $t("ct-delete") }}
      </button>
    </sweet-modal>

    <!-- MODAL DELETE SELECT WEBSITES   -->
    <sweet-modal
      ref="confirmDeleteSelectedAllWebsites"
      width="496px"
      hide-close-button
      class="modal-confirm-deleted-websites"
      blocking
    >
      <alert-box-new-component :with_icon="true" type="danger">
        <span slot="content">{{ $t("ct-modal-deleted-attention") }}</span>
      </alert-box-new-component>
      <p>{{ $t("ct-modal-deleted-all-websites-description") }}</p>

      <div class="form-group">
        <label for="email">{{ $t("ct-modal-deleted-confirm-email") }}</label>
        <input
          type="email"
          id="email"
          class="form-control"
          :placeholder="$t('ct-email')"
          v-model="confirm_email"
          required
        />
      </div>

      <button
        slot="button"
        class="btn btn-outline-light"
        @click.prevent="$refs.confirmDeleteSelectedAllWebsites.close()"
      >
        {{ $t("ct-cancel") }}
      </button>
      <button
        slot="button"
        class="btn btn-danger"
        @click.prevent="confirmDeletedWebsites"
      >
        {{ $t("ct-delete") }}
      </button>
    </sweet-modal>

    <sweet-modal
      ref="alertDisconnectDomain"
      width="25%"
      hide-close-button
      blocking
    >
      <div v-if="modal.alertDisconnectDomain.action === 'transfer'">
        {{ $t("ct-disconnect-domain-before-transfer") }}
      </div>
      <div v-else>{{ $t("ct-disconnect-domain-before-delete") }}</div>
      <button
        slot="button"
        class="btn btn-outline-primary mt-2"
        @click="closeAlertDisconnectDomain"
      >
        {{ $t("ct-ok") }}
      </button>
    </sweet-modal>
  </div>
</template>

<script>
import ModalComponent from "./components/Modal.vue";
import ModalUploadImageComponent from "./components/ModalUploadImage";
import PaginationComponent from "./components/Pagination.vue";

import NavComponent from "./layout/nav/Nav.vue";
import SiteNewComponent from "./layout/site/SiteNew.vue";
import SiteCardComponent from "./layout/site/SiteCard.vue";
import MainSiteCardComponent from "./layout/site/MainSiteCard.vue";
import SkeletonCardSiteComponent from "./layout/site/SkeletonCardSite";
import SiteTransferComponent from "./layout/site/SiteTransfer";
import SitePublicLinkComponent from "./layout/site/SitePublicLink";
import SiteCategoryComponent from "./layout/site/SiteCategory";
import SitePublishComponent from "./layout/site/SitePublish";
import SaveWebsiteComponent from "./components/SaveWebsiteComponent";
import FirstWebsite from "./FirstWebsite";
import Breadcrumbs from "../general/Breadcrumbs.vue";

import {
  edit as editCategory,
  exclude as excludeCategory,
  getCategories,
} from "../../js/services/category";
import {
  deletedWebsitesSelected,
  exclude as excludeWebsite,
  getAllWebsites,
  getDashboardData,
} from "../../js/services/editor/website";
import { editConfiguration as editConfigurationPage } from "./../../js/services/editor/page";
import { get as getMirrors } from "./../../js/services/editor/mirror";

import { mapActions, mapGetters } from "vuex";
import { SweetModal } from "sweet-modal-vue";
import AlertBoxNewComponent from "../commons/AlertBoxNewComponent.vue";
import ModalDeleteComponent from "./components/ModalDelete.vue";
import SiteDomainComponent from "./layout/site/SiteDomain.vue";
import MoveCategory from "./modals/MoveCategory.vue";

const MAINCARD_LISTING_SIZE = 3;
const MAINCARD_FIRST_PAGE_SIZE = MAINCARD_LISTING_SIZE + 1;
const DEFAULT_PER_PAGE = 12;

export default {
  name: "Dashboard",
  components: {
    MoveCategory,
    SiteDomainComponent,
    ModalDeleteComponent,
    AlertBoxNewComponent,
    FirstWebsite,
    SiteNewComponent,
    ModalComponent,
    NavComponent,
    SiteCardComponent,
    MainSiteCardComponent,
    PaginationComponent,
    ModalUploadImageComponent,
    SiteTransferComponent,
    SitePublicLinkComponent,
    SiteCategoryComponent,
    SweetModal,
    SitePublishComponent,
    SaveWebsiteComponent,
    SkeletonCardSiteComponent,
    Breadcrumbs,
  },
  props: ["openNewSiteModal"],
  data() {
    return {
      loading: true,
      loaded: false,
      notHaveWebsites: false,
      loadingContentData: false,
      loadingAll: false,
      confirm_email: "",
      modalDomain: {
        show: 0,
      },
      pagination: {
        normal: {
          current_page: 1,
          per_page: 12,
        },
      },
      categories: false,
      typeView: "maincard",
      selectWebsites: {
        type: "unitary", // unitary or all
        selectedWebsites: [],
        total: 0,
      },
      selectMirrors: false,
      languages: [],
      websites_all: [],
      websites: {
        normal: [],
        mirrors: [],
        turbo: [],
      },
      websitesLength: {
        mirrors: 5,
        normal: 5,
      },
      mirrors: [],
      newSite: {
        showModal: false,
        title: "",
        dominio: "",
        description: "",
        categories: [],
        image: "",
        status: "inactive",
        language: this.$i18n.locale,
        typeInitial: "",
        typeBuilder: {
          build: {
            header: "",
            footer: "",
            body: "",
          },
          template: {
            idTemplate: "",
          },
        },
      },
      filters: {
        category: String(),
        status: "",
        search: String(),
        order: "desc", // (asc desc)
        type: "",
        only_favorites: false,
      },
      dashboardData: {
        qty_websites: 0,
        qty_domains: 0,
        qty_visits: 0,
      },
      periodDashboardData: "all", // week, month, all
      loadingDashboardData: false,
      filterSitesOrder: localStorage.getItem("websites-order") || "edition_asc",
      filterPublishedUnpublished: "",
      showExitPopupAlert: false,
    };
  },

  computed: {
    ...mapGetters({ modal: "dashboard/modal" }),

    showMainSiteCard() {
      return (
        this.typeView === "maincard" &&
        this.pagination.normal.current_page === 1 &&
        this.websites.normal.length > 0
      );
    },

    mainWebsite() {
      return this.websites.normal[0] || null;
    },

    hasFilters() {
      return this.filters.search || this.filters.category || this.filters.status || this.filters.only_favorites;
    },

    displayWebsites() {
      if (this.typeView !== "maincard") {
        return this.websites.normal;
      }

      if (this.pagination.normal.current_page === 1) {
        return this.websites.normal.slice(1, MAINCARD_FIRST_PAGE_SIZE);
      }

      return this.websites.normal;
    },

    skeletonCount() {
      if (this.typeView === "maincard") {
        return this.pagination.normal.current_page === 1
          ? MAINCARD_LISTING_SIZE
          : DEFAULT_PER_PAGE;
      }

      return this.websitesLength.normal;
    },

    showPagination() {
      if (!this.websites.normal || !this.pagination.normal.total) {
        return false;
      }

      if (this.typeView === "maincard") {
        return this.pagination.normal.total > MAINCARD_FIRST_PAGE_SIZE;
      }

      return this.pagination.normal.total > this.pagination.normal.per_page;
    },
  },

  watch: {
    filterSitesOrder: function () {
      this.paginationChange();
    },
    filterPublishedUnpublished: function () {
      this.paginationChange(1);
    },
    "getUser.lang": function (value) {
      this.newSite.language = value;
    },
    typeView: function (newView, oldView) {
      localStorage.setItem("websites-type-view", newView);

      if (!oldView || newView === oldView) {
        return;
      }

      if (newView === "maincard" || oldView === "maincard") {
        if (newView !== "maincard") {
          this.pagination.normal.per_page = DEFAULT_PER_PAGE;
        }

        this.paginationChange(1);
      }
    },
    "modal.alertDisconnectDomain.show": function (val) {
      if (val) {
        this.$refs.alertDisconnectDomain.open();
      }
    },
  },

  methods: {
    ...mapActions({
      closeModalDisconnectDomain: "dashboard/closeModalDisconnectDomain",
    }),

    closeAlertDisconnectDomain() {
      this.closeModalDisconnectDomain();
      this.$refs.alertDisconnectDomain.close();
    },

    newWebsite() {
      this.$router.push({
        name: "CreateWebsite",
        query: { step: "template" },
      });
    },

    deletedWebsites() {
      if (this.selectWebsites.type === "all") {
        this.$refs.confirmDeleteSelectedAllWebsites.open();
      } else {
        this.$refs.confirmDeleteSelectedWebsites.open();
      }
    },

    confirmDeletedWebsites() {
      if (this.selectWebsites.type === "all" && !this.confirm_email.length) {
        return;
      }

      this.loadingAll = true;
      deletedWebsitesSelected({
        ...this.selectWebsites,
        confirm_email: this.confirm_email,
      })
        .then(() => {
          this.$refs.confirmDeleteSelectedWebsites.close();
          this.$refs.confirmDeleteSelectedAllWebsites.close();
          this.confirm_email = "";
          this.clearSelect();
          this.updateWebsites();
        })
        .catch(() => {
          this.$snotify.warning(
            this.$t("ct-modal-deleted-confirm-email-error")
          );
        })
        .finally(() => {
          this.loadingAll = false;
        });
    },

    ...mapGetters({ getUser: "user" }),

    closeMoveCategory() {
      this.categorySelected = false;
      this.$refs.moveFile.close();
    },

    publish(show, website) {
      this.modal.publish = {
        show: show,
        config: website,
      };

      this.modal.saveTour.config = website;
    },

    deleteWebsite(website) {
      this.loadingAll = true;

      excludeWebsite(website)
        .then(() => {
          this.cancelModal("delete");
          this.updateWebsites();
        })
        .catch((error) => console.warn(error))
        .finally(() => (this.loadingAll = false));
    },

    openSaveTour(website) {
      if (website) {
        this.modal.saveTour.config = website;
      }

      this.modal.saveTour.show = false;

      this.$nextTick(() => {
        this.modal.saveTour.show = 1;
      });
    },

    disconnectDomain() {
      this.modal.domain.show = true;
      this.modal.domain.type = "disconnect";
      this.modal.domain.title = this.$t("ct-domain-info");
    },

    cancelModal(type) {
      if (this.$refs[type]) {
        this.$refs[type].close();
        return;
      }
      this.modal[type].show = false;
      this.modal[type].config = "";

      document.querySelector("body").style.overflow = "";
      document.querySelector("body").style.height = "";
    },

    updateFavorite(params) {
      this.websites.normal.find((s) => s.id == params.site_id).is_favorite =
        params.is_favorite;
      if (this.filterPublishedUnpublished === "favorites") {
        this.paginationChange();
      }
    },

    updateWebsites() {
      this.loadingAll = true;

      this.paginationChange(this.pagination.normal.current_page)
        .catch((error) => console.warn(error))
        .finally(() => {
          this.loadingAll = false;
        });
    },

    confirmSave(website) {
      this.$router.push({
        name: "SitePages",
        params: { id: website.encrypted_id },
      });
    },

    clearNewSite() {
      this.newSite = {
        showModal: false,
        title: "",
        url: "",
        dominio: "",
        description: "",
        language: this.$i18n.locale,
        categories: [],
        image: "",
        status: "inactive",
        typeInitial: "",
        typeBuilder: {
          build: {
            header: "",
            footer: "",
            body: "",
          },
          template: {
            idTemplate: "",
          },
        },
      };
    },

    closeModal() {
      this.newSite.showModal = false;
    },

    selectedWebsitesAll() {
      this.selectWebsites.type =
        this.selectWebsites.type === "all" ? "unitary" : "all";
      this.selectWebsites.selectedWebsites = [];

      if (this.selectWebsites.type === "all")
        this.selectWebsites.total = this.pagination.normal.total;
      else
        this.selectWebsites.total = this.selectWebsites.selectedWebsites.length;

      this.$refs["select-all-websites"].checked = true;
    },

    checkedSelectAll(userEmail) {
      if (this.selectWebsites.type === "all") {
        this.selectWebsites.type = "unitary";
        this.$refs["select-all-websites"].checked = false;
      }

      if (!this.selectWebsites.selectedWebsites.includes(userEmail))
        this.selectWebsites.selectedWebsites.push(userEmail);

      this.changeUnitary();
    },

    changeUnitary() {
      this.selectWebsites.total = this.selectWebsites.selectedWebsites.length;
    },

    clearSelect() {
      this.selectWebsites = {
        type: "unitary", // unitary or all
        selectedWebsites: [],
        total: 0,
      };
    },

    getMaincardLastPage(total) {
      if (total <= MAINCARD_FIRST_PAGE_SIZE) {
        return 1;
      }

      return 1 + Math.ceil((total - MAINCARD_FIRST_PAGE_SIZE) / DEFAULT_PER_PAGE);
    },

    getMaincardOffset(uiPage) {
      if (uiPage === 1) {
        return 0;
      }

      return MAINCARD_FIRST_PAGE_SIZE + (uiPage - 2) * DEFAULT_PER_PAGE;
    },

    fetchWebsitesFromOffset(offset, limit) {
      const perPage = DEFAULT_PER_PAGE;
      const firstApiPage = Math.floor(offset / perPage) + 1;
      let skip = offset % perPage;
      let collected = [];

      const fetchNext = (apiPage) => {
        return getAllWebsites(apiPage, this.filters, perPage).then(({ data }) => {
          const batch = data.data.slice(skip);
          skip = 0;
          collected = collected.concat(batch);

          if (collected.length >= limit || apiPage >= data.last_page) {
            return { data, items: collected.slice(0, limit) };
          }

          return fetchNext(apiPage + 1);
        });
      };

      return fetchNext(firstApiPage);
    },

    fetchMaincardWebsites(uiPage) {
      if (uiPage === 1) {
        return getAllWebsites(1, this.filters, MAINCARD_FIRST_PAGE_SIZE);
      }

      const offset = this.getMaincardOffset(uiPage);

      return this.fetchWebsitesFromOffset(offset, DEFAULT_PER_PAGE).then(
        ({ data, items }) => ({
          data: {
            ...data,
            data: items,
          },
        })
      );
    },

    applyWebsitesResponse(data, uiPage) {
      this.websites.normal = data.data;

      if (this.typeView === "maincard") {
        this.pagination.normal = {
          ...this.paginationData(data),
          current_page: uiPage,
          last_page: this.getMaincardLastPage(data.total),
        };
      } else {
        this.pagination.normal = this.paginationData(data);
      }

      this.addParamsToLocation(this.filters);
      this.emitHasWebsitesStatus();
    },

    emitHasWebsitesStatus() {
      const total = this.pagination.normal && this.pagination.normal.total;
      const hasWebsites = typeof total === 'number'
        ? total > 4 || this.hasFilters
        : this.websites.normal.length > 4 || this.hasFilters;

      this.$root.$emit('dashboard-has-websites', hasWebsites);
    },

    paginationChange(currentPage = null, perPage = null) {
      this.loadingContentData = true;
      this.defineFilters();

      const uiPage = currentPage || this.pagination.normal.current_page;

      if (this.typeView === "maincard") {
        return this.fetchMaincardWebsites(uiPage)
          .then(({ data }) => {
            this.applyWebsitesResponse(data, uiPage);
          })
          .finally(() => {
            this.loadingContentData = false;
          });
      }

      const effectivePerPage = perPage != null ? perPage : DEFAULT_PER_PAGE;

      return getAllWebsites(uiPage, this.filters, effectivePerPage)
        .then(({ data }) => {
          this.applyWebsitesResponse(data, uiPage);
        })
        .finally(() => {
          this.loadingContentData = false;
        });
    },

    showMore(quantity) {
      if (this.typeView === "maincard") {
        return;
      }

      this.paginationChange(
        null,
        +this.pagination.normal.per_page + quantity
      );
    },

    defineFilters() {
      localStorage.setItem("websites-order", this.filterSitesOrder);

      const orderMap = {
        alphabetical_desc: { type: "alphabetical", order: "desc" },
        alphabetical_asc: { type: "alphabetical", order: "asc" },
        creation_asc: { type: "creation", order: "asc" },
        creation_desc: { type: "creation", order: "desc" },
        edition_asc: { type: "edition", order: "asc" },
      };

      const selected = orderMap[this.filterSitesOrder] || {
        type: "",
        order: "",
      };

      this.filters.type = selected.type;
      this.filters.order = selected.order;

      if (this.filterPublishedUnpublished === "active") {
        this.filters.only_favorites = 0;
        this.filters.status = "active";
      } else if (this.filterPublishedUnpublished === "inactive") {
        this.filters.only_favorites = 0;
        this.filters.status = "inactive";
      } else if (this.filterPublishedUnpublished === "favorites") {
        this.filters.only_favorites = 1;
        this.filters.status = "";
      } else if (this.filterPublishedUnpublished === "mirrors") {
        this.filters.only_favorites = 0;
        this.filters.status = "";
        this.selectMirrors = true;
      } else {
        this.filters.only_favorites = 0;
        this.filters.status = "";
      }
    },

    addParamsToLocation(params) {
      let str = Object.keys(params)
        .map((key) => {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
      let uri = window.location.href.toString();

      if (uri.indexOf("?") > 0) uri = uri.substring(0, uri.indexOf("?"));

      if (str) window.location.href = uri + "?" + str;
    },

    openNewCategory() {
      this.$refs.categoryModal.open();
    },

    cancelCategory() {},

    newCategory(category) {
      this.categories.push(category);
      this.updateWebsites();
    },

    updateCategory(category) {
      this.loadingAll = true;
      editCategory(category)
        .then((data) => {
          console.log("CATEGORY - EDIT");
        })
        .catch((error) => {
          console.warn(error);
        })
        .finally(() => (this.loadingAll = false));
    },

    deleteCategory(category) {
      this.loadingAll = true;
      excludeCategory(category)
        .then((data) => {
          this.removeCategory(category);
          this.clearCategory();
        })
        .catch((error) => {
          console.warn(error);
        })
        .finally(() => (this.loadingAll = false));
    },

    removeCategory(category) {
      // Deleta a categoria do objeto
      this.categories = this.categories.filter(function (element) {
        return element.id !== category.id;
      });
    },

    saveImagePage(image) {
      let configuration = {
        og_image: image,
      };

      if (this.modal.image.page.configuration) {
        this.modal.image.page.configuration.og_image = image;
      } else
        this.modal.image.page = { ...this.modal.image.page, configuration };

      editConfigurationPage(this.modal.image.page)
        .then((data) => {
          this.closeUploadPage();
          window.location.reload();
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    closeUploadPage() {
      let values = {
        action: "close",
        type: "Images",
        save: this.saveImagePage,
        close: this.closeUploadPage,
      };

      this.$root.$emit("fileMananger", values);

      this.modal.image = {
        show: false,
        page: "",
      };
    },

    uploadImagePage(page) {
      this.modal.image.page = page;

      let values = {
        action: "open",
        type: "Images",
        save: this.saveImagePage,
        close: this.closeUploadPage,
      };

      this.$root.$emit("fileMananger", values);
    },

    /* public link website - begin */
    openPublicLink(show, config = "", action = "") {
      this.modal.publicLink = {
        show: show,
        action: action,
        config: config,
      };
    },
    /* public link website - end */
    paginationData(data) {
      let page_meta = {
        current_page: data.current_page,
        last_page: data.last_page,
        from: data.from,
        path: data.path,
        per_page: data.per_page,
        to: data.to,
        total: data.total,
      };

      return page_meta;
    },

    getWebsitesData() {
      let self = this;
      this.paginationChange();
      getAllWebsites(1, this.filters).then((res) => {
        self.websites.normal = res.data.data;
      });
    },

    getStorageFilters() {
      try {
        let filtersWebsites = localStorage.getItem(
          "dashboard-filters-website-list"
        );

        if (!filtersWebsites) return;

        let filters = JSON.parse(filtersWebsites);

        this.filters.order = filters.order;
        this.filters.type = filters.type;
      } catch (e) {
        console.warn(e);
      }
    },

    setQueryParams() {
      let query = this.$route.query;

      if (query.category) this.filters.category = query.category;

      if (query.search) this.filters.search = query.search;
    },

    getCategory() {
      let category_id = this.filters.category;
      if (category_id && this.categories)
        return this.categories.find(
          (category) => category.id === parseInt(category_id)
        );

      return false;
    },

    clearCategory() {
      this.filters.category = false;
      if (this.$refs["filters-component"])
        this.$refs["filters-component"].changeCategory(false);
    },

    websitesLengthLoad() {
      if (localStorage.getItem("websites-normal-length") !== null) {
        const countItem = parseInt(
          localStorage.getItem("websites-normal-length")
        );
        this.websitesLength.normal = countItem ? countItem : 5;
      }
    },

    typeViewLoad() {
      if (localStorage.getItem("websites-type-view") !== null)
        this.typeView = localStorage.getItem("websites-type-view");
    },

    getDashboardUserData() {
      this.loadingDashboardData = true;
      getDashboardData(this.periodDashboardData)
        .then((res) => {
          if (res.status == 200) {
            this.dashboardData = res.data;
          }
        })
        .finally(() => {
          this.loadingDashboardData = false;
        });
    },

    handleWebsiteSearch(searchTerm) {
      this.filters.search = searchTerm || "";
      this.paginationChange(1);
    },
  },

  beforeDestroy() {
    this.$root.$off("dashboard-website-search", this.handleWebsiteSearch);
    this.$root.$off("dashboard-refresh-websites", this.updateWebsites);
  },

  async mounted() {
    this.$root.$on("dashboard-website-search", this.handleWebsiteSearch);
    this.$root.$on("dashboard-refresh-websites", this.updateWebsites);

    this.newSite.showModal = this.openNewSiteModal;

    let self = this;

    this.typeViewLoad();
    this.websitesLengthLoad();
    await this.getDashboardUserData();
    this.defineFilters();

    await this.getStorageFilters();
    await this.setQueryParams();

    this.loadingAll = true;

    const initialPerPage =
      self.typeView === "maincard" ? MAINCARD_FIRST_PAGE_SIZE : DEFAULT_PER_PAGE;

    await Promise.all([
      getCategories(),
      getAllWebsites(1, this.filters, initialPerPage),
      getMirrors(),
    ])
      .then((data) => {
        const [categories, websites, mirrors] = data;

        self.categories = categories.data;

        self.websites.normal = websites.data.data;

        if (self.typeView === "maincard") {
          self.pagination.normal = {
            ...self.paginationData(websites.data),
            current_page: 1,
            last_page: self.getMaincardLastPage(websites.data.total),
          };
        } else {
          self.pagination.normal = {
            ...self.paginationData(websites.data),
            per_page: DEFAULT_PER_PAGE,
          };
        }

        localStorage.setItem(
          "websites-normal-length",
          websites.data.data.length
        );

        if (
          websites.data.data.length === 0 &&
          self.dashboardData.qty_websites == 0
        ) {
          self.notHaveWebsites = true;
        }

        /** MIRROR - ALAN */
        self.websites.mirrors = mirrors.data;

        self.emitHasWebsitesStatus();
      })
      .catch((error) => {
        console.warn(error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loadingAll = false;
          this.loading = false;
        }, 1200);
      });

    /* component ref does not exists
    this.$nextTick(() => {
      this.$refs['filters-component'].setOrderBySelected();

      let category = this.getCategory();
      if (category) this.$refs['filters-component'].changeCategory(category);
    });
    */

    if (localStorage.getItem("is_bundle") == "show-message") {
      this.showExitPopupAlert = true;
    }
  },

  beforeDestroy() {
    this.$root.$off("dashboard-website-search", this.handleWebsiteSearch);
    this.$root.$emit("dashboard-has-websites", false);
  },
};
</script>

<style lang="scss" scoped>
.ba-container {
  padding-bottom: 48px;
}

.ba-card.ba-statistics .ba-content .ba-data {
  font-size: 44px;
}

.custom-container {
  .maincard-header {

    .maincard-title {
      font-size: 18px;
      font-weight: 600;
      color: #3D3D3D;
    }

    .maincard-view-all {
      display: flex;
      align-items: center;
      gap: 10px;
      color: #0072E1;
      font-size: 14px;
      font-weight: 600;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;

      builderall-icon {
        --builderall-icon-size: 16px;
      }
    }
  }
}

.dashboard-choose-view {
  div {
    color: #c4d1e0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    cursor: pointer;

    &.selected {
      color: #0080fc;
    }

    &:hover {
      scale: 1.05;
      transition: 100ms;
    }
  }

  i[class^="ct-icon-"] {
    font-size: 24px;
    cursor: pointer;
    display: flex;
  }

  svg {
    cursor: pointer;
  }
}

.container-dashboard {
  min-width: 300px;
  min-height: calc(100vh - 80px);
  padding-bottom: 100px;
}

.nav-list-websites {
  display: flex;
  justify-content: center;
  align-items: center;

  border-bottom: 1px solid rgba(#0080fc, 0.5);

  .nav-link {
    font-family: "Muli", sans-serif;
    font-size: 16px;
    color: #434343;
    text-transform: capitalize;
    border: 0;
    transition: color 0.2s;

    cursor: pointer;

    &.active {
      font-weight: bold;
      color: #0080fc;
      background: #e9edf2;
      border: 0;
      border-bottom: 3px solid #0080fc;
    }
  }
}

.button-tag {
  height: 40px;
  margin-top: 3px !important;
  text-transform: uppercase;
}

.container-box {
  padding: 0;

  @media (max-width: 576px) {
    padding: 0;
  }
}

.dropdown-menu {
  right: 0;
  left: auto;
  z-index: 1050;
}

.box {
  width: 23%;
}

.new-website {
  background: #f8fafd 0% 0% no-repeat padding-box;
  border: 1px dashed #05c1fc;
  cursor: pointer;
  border-radius: 16px;
  min-height: 259px;
}

.new-website .btn:hover {
  color: #0056b3;
}

.builder-action-multiple-websites_checkbox-all-label {
  margin-bottom: 0;
}

.box-info {
  display: flex;
  flex-direction: column;
  text-align: center;
}

@media (max-width: 575.98px) {
  .box {
    max-width: 94%;
    min-width: 300px;
    margin: 15px 3%;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .box {
    max-width: 90%;
    min-width: 300px;
    margin: 15px 5%;
  }
}

@media (min-width: 768px) and (max-width: 1049.99px) {
  .box {
    max-width: 46%;
    min-width: 300px;
    margin: 15px 2%;
  }

  .btn-add-tag {
    font-size: 10px !important;
    margin-right: 30px !important;
  }
}

@media (min-width: 1050px) and (max-width: 1299.98px) {
  .box {
    max-width: 31.33%;
    min-width: 31.33%;
    margin: 15px 1%;
  }
}

@media (min-width: 1300px) {
  .box {
    min-width: 31.33%;
    max-width: 31.33%;
    margin: 0 1% 15px 1%;
  }
}

.show-more {
  font-size: 12px;
  color: #0072e1 !important;
  cursor: pointer;
  &:hover {
    text-decoration: underline !important;
  }
  span {
    background-color: #f5f7fe;
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue